import { render, staticRenderFns } from "./modal-delete-member.vue?vue&type=template&id=9504a412&scoped=true&"
import script from "./modal-delete-member.vue?vue&type=script&lang=js&"
export * from "./modal-delete-member.vue?vue&type=script&lang=js&"
import style0 from "./modal-delete-member.vue?vue&type=style&index=0&id=9504a412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9504a412",
  null
  
)

/* custom blocks */
import block0 from "./modal-delete-member.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports